export default "/_next/static/images/Falcon_wordmark_white-8f15aba29a9db23d21594726e93d8652.svg";